module.exports = __webpack_public_path__ + "img/p3_4.bac2a399.png";